import { render, staticRenderFns } from "./ProjectsTimeline.vue?vue&type=template&id=308e6bd3&scoped=true&"
import script from "./ProjectsTimeline.vue?vue&type=script&lang=js&"
export * from "./ProjectsTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsTimeline.vue?vue&type=style&index=0&id=308e6bd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308e6bd3",
  null
  
)

export default component.exports